/** Shared "How did you hear about us?" options — signup and the later prompt. */
export const REFERRAL_SOURCE_OPTIONS = [
  "Google or another search engine",
  "Instagram",
  "TikTok",
  "Facebook",
  "YouTube",
  "Pinterest",
  "A friend or family member",
  "A therapist or practitioner",
  "A podcast or article",
  "Other",
] as const;

export type ReferralSource = (typeof REFERRAL_SOURCE_OPTIONS)[number];
